import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M3.642 2.955a6.666 6.666 0 019.818 8.871L11.333 8h2a5.334 5.334 0 00-9.027-3.848l-.664-1.197zm8.716 10.09A6.666 6.666 0 012.54 4.173l2.126 3.826h-2a5.334 5.334 0 009.027 3.848l.665 1.196z"
      ></path>
    </svg>
  )
}

export default Icon
